import React from 'react';
import { withRouter } from 'react-router-dom';
import { Level, Title } from 'rbx';
import styled from 'styled-components';
import Can from '../../../utils/Can';
import { ACLSConsumer } from '../../../utils/aclsContext';
import { SubHeading } from '../../../components/elements';

const Wrapper = styled.div`
  padding: 1rem;
  .level:not(:last-child) {
    margin-bottom: 0;
  }
`;

// const Note = styled.div`
//   padding: 0.5rem;
//   margin-left: 0.5rem;
// `;

const Header = ({
  activeTab,
  prev,
  next,
  heading,
  loading,
  action,
  status,
  handleApprovedAction,
  handleRejectAction,
  subHeading,
  itemName,
  updateItemReviewLoading,
  handleUpdateReview,
  history,
  location,
  placeListingStatus,
}) => (
  // useEffect(() => {
  //   if (placeListingStatus !== 'APPROVED') {
  //     toast.warn(
  //       <p>
  //         Place listing is not approved. Place listing must be reviewed and
  //         approved before, then the item listing can be approved
  //       </p>,
  //     );
  //   }
  // }, []);

  <Wrapper>
    <Level>
      <Level.Item align="left">
        <Title size={2}>{heading}</Title>
      </Level.Item>
      <Level.Item align="right">
        <Level.Item>
          <a onClick={() => history.goBack()} className="button is-light">
            <span>Cancel</span>
          </a>
        </Level.Item>
        {activeTab !== 0 && (
          <Level.Item>
            <button onClick={prev} className="button is-primary">
              <span>Prev Tab</span>
            </button>
          </Level.Item>
        )}
        <ACLSConsumer>
          {({ apiActions, pageActions }) => (
            <Can
              action={`${
                location.pathname === '/item-review'
                  ? 'action_item_review'
                  : 'action_item_review'
              }`}
              apiActions={apiActions}
              pageActions={pageActions}
              yes={() => (
                <>
                  {status !== 'REJECTED' && (
                    <Level.Item>
                      <button
                        className={`button is-danger ${action === 'REJECTED' &&
                          loading &&
                          'is-loading'}`}
                        onClick={handleRejectAction}
                        disabled={status === 'REJECTED'}
                      >
                        <span>Reject</span>
                      </button>
                    </Level.Item>
                  )}
                </>
              )}
            />
          )}
        </ACLSConsumer>

        <ACLSConsumer>
          {({ apiActions, pageActions }) => (
            <Can
              action={`${
                location.pathname === '/item-review'
                  ? 'action_item_review'
                  : 'action_item_review'
              }`}
              apiActions={apiActions}
              pageActions={pageActions}
              yes={() => (
                <>
                  {placeListingStatus !== 'APPROVED' && (
                    <Level.Item>
                      <button
                        className={`button is-primary ${action === 'APPROVED' &&
                          loading &&
                          'is-loading'}`}
                        onClick={handleApprovedAction}
                        disabled
                      >
                        <span>Approve and Publish</span>
                      </button>
                    </Level.Item>
                  )}
                </>
              )}
            />
          )}
        </ACLSConsumer>

        <ACLSConsumer>
          {({ apiActions, pageActions }) => (
            <Can
              action={`${
                location.pathname === '/item-review'
                  ? 'action_item_review'
                  : 'action_item_review'
              }`}
              apiActions={apiActions}
              pageActions={pageActions}
              yes={() => (
                <>
                  {status !== 'APPROVED' && placeListingStatus === 'APPROVED' && (
                    <Level.Item>
                      <button
                        className={`button is-primary ${action === 'APPROVED' &&
                          loading &&
                          'is-loading'}`}
                        onClick={handleApprovedAction}
                        disabled={status === 'APPROVED'}
                      >
                        <span>Approve and Publish</span>
                      </button>
                    </Level.Item>
                  )}
                </>
              )}
            />
          )}
        </ACLSConsumer>

        <ACLSConsumer>
          {({ apiActions, pageActions }) => (
            <Can
              action={`${
                location.pathname === '/item-review'
                  ? 'update_item_review'
                  : 'update_item_review'
              }`}
              apiActions={apiActions}
              pageActions={pageActions}
              yes={() => (
                <Level.Item>
                  <button
                    className={`button is-primary ${updateItemReviewLoading &&
                      'is-loading'}`}
                    onClick={handleUpdateReview}
                  >
                    <span>Update Review</span>
                  </button>
                </Level.Item>
              )}
            />
          )}
        </ACLSConsumer>

        {status === 'SUBMITTED' && activeTab !== 1 && (
          <Level.Item>
            <button onClick={next} className="button is-primary">
              <span>Next Tab</span>
            </button>
          </Level.Item>
        )}

        {status !== 'SUBMITTED' && activeTab !== 4 && (
          <Level.Item>
            <button onClick={next} className="button is-primary">
              <span>Next Tab</span>
            </button>
          </Level.Item>
        )}
      </Level.Item>
    </Level>

    <SubHeading className="is-size-2">{itemName}</SubHeading>
    <SubHeading className="is-size-2">{subHeading}</SubHeading>
  </Wrapper>
);
export default withRouter(Header);
